import { makeStyles } from '@material-ui/core/styles';

// 選單最外層的 container
export const useSelectStyle = makeStyles(theme => ({
  select: {
    padding: '3px 0 3px 5px',
    display: 'inline-flex',
    backgroundColor: theme.palette.common.white,
    height: '36px',
  },
}));

export const useCustomOptionStyle = makeStyles(theme => ({
  menuItem: {
    padding: 0,
    minHeight: '30px',
    backgroundColor: theme.palette.common.white,

    '&:hover': {
      backgroundColor: 'unset',
    },

    '&.Mui-selected': {
      backgroundColor: 'unset',
      '&:hover': {
        backgroundColor: 'unset',
      },
    },

    '&:first-child': {
      backgroundColor: 'unset',
    },

    '&:not(:last-child)': {
      marginBottom: '8px',
    },
  },
  // 選單內的 checkbox
  checkbox: {
    padding: 0,
    marginRight: '10px',
    color: theme.palette.grey['A400'],
  },
  // 選單內的灰底元素
  root: {
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    color: theme.palette.grey[600],
    backgroundColor: theme.palette.grey[100],
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.5,
    borderRadius: theme.spacing(0.5),
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: 'calc(100% - 16px)',
    transition: '0.2s',
    transitionProperty: 'color, background-color',
  },
  var: {
    '&::before': {
      content: '"# "',
    },
  },
}));
